module.exports = __webpack_public_path__ + "img/animation.aba68877.gif";